var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.4,
    height: 9.618,
    viewBox: "0 0 9.4 9.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818",
    transform: "translate(-12 -14.96)",
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_payment-ils",
    "data-name": "Icon payment-ils",
    d: "M18.85,24.778a.217.217,0,0,1-.219.219H17.537a.216.216,0,0,1-.218-.219V21.39a1.861,1.861,0,0,0-1.858-1.858H13.6V27.4a.217.217,0,0,1-.219.219H12.291a.216.216,0,0,1-.218-.219v-9.18A.216.216,0,0,1,12.291,18h3.17A3.388,3.388,0,0,1,18.85,21.39v3.388Zm2.623-.546a3.388,3.388,0,0,1-3.389,3.388h-3.17A.216.216,0,0,1,14.7,27.4V20.845a.216.216,0,0,1,.218-.219h1.093a.217.217,0,0,1,.219.219v5.246h1.857a1.861,1.861,0,0,0,1.858-1.858V18.221A.216.216,0,0,1,20.16,18h1.093a.217.217,0,0,1,.219.219v6.011Z",
    transform: "translate(-0.073 -3.042)",
    fill: "#242323"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.ab90725981fe8286d07509ece311dd65.svg";
export { ForwardRef as ReactComponent };